<template>
  <div class="admin-referral">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="mb-0 text-white">邀请记录管理</h4>
    </div>

    <!-- 记录表格 -->
    <div class="card bg-dark-soft border-0 shadow-sm">
      <div class="card-body p-0">
        <!-- PC端表格视图 -->
        <div class="d-none d-lg-block">
          <div class="table-responsive">
            <table class="table table-dark table-hover mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>时间</th>
                  <th>邀请人</th>
                  <th>被邀请人</th>
                  <th>奖励积分</th>
                  <th>状态</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.created_at }}</td>
                  <td>
                    <div class="text-primary font-weight-bold">
                      {{ item.referrer.name }}
                      <span v-if="item.referrer.is_suspicious" class="badge badge-danger ml-1">嫌疑人</span>
                    </div>
                    <div class="d-flex align-items-center mt-1">
                      <small class="text-muted mr-2">ID: {{ item.referrer.id }}</small>
                      <a href="javascript:void(0)" 
                         :class="item.referrer.is_suspicious ? 'text-warning' : 'text-danger'"
                         style="font-size: 0.75rem; text-decoration: none;"
                         @click.prevent="toggleSuspicious(item.referrer.id, item.referrer.name, !item.referrer.is_suspicious)"
                      >
                        [{{ item.referrer.is_suspicious ? '取消嫌疑' : '设为嫌疑' }}]
                      </a>
                    </div>
                  </td>
                  <td>
                    <div class="text-success font-weight-bold">{{ item.referee.name }}</div>
                    <small class="text-muted">ID: {{ item.referee.id }}</small>
                  </td>
                  <td>
                    <span class="badge badge-pill badge-warning">+{{ item.points }}</span>
                  </td>
                  <td>
                    <span v-if="item.status === 0" class="badge badge-warning">审核中</span>
                    <span v-else-if="item.status === 2" class="badge badge-danger">未通过</span>
                    <span v-else class="badge badge-success">已通过</span>
                  </td>
                  <td>
                    <template v-if="item.status === 0">
                      <button class="btn btn-sm btn-success mr-2" @click="audit(item.id, true, item.status)">通过</button>
                      <button class="btn btn-sm btn-danger" @click="audit(item.id, false, item.status)">拒绝</button>
                    </template>
                    <template v-else-if="item.status === 1">
                      <button class="btn btn-sm btn-outline-danger" @click="audit(item.id, false, item.status)">改未通过</button>
                    </template>
                    <span v-else class="text-muted">-</span>
                  </td>
                </tr>
                <tr v-if="items.length === 0 && !loading">
                  <td colspan="7" class="text-center py-5 text-muted">暂无邀请记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 移动端卡片视图 -->
        <div class="d-lg-none referral-mobile-list p-2">
          <div v-for="item in items" :key="item.id" class="referral-mobile-card mb-2 p-2 bg-dark-soft rounded border border-secondary shadow-sm">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-white font-weight-bold" style="font-size: 0.9rem;">记录 #{{ item.id }}</span>
              <span class="text-white-50" style="font-size: 0.75rem;">{{ item.created_at.substring(5, 16) }}</span>
              <span v-if="item.status === 0" class="badge badge-warning py-0 px-1" style="font-size: 0.75rem;">审核中</span>
              <span v-else-if="item.status === 2" class="badge badge-danger py-0 px-1" style="font-size: 0.75rem;">未通过</span>
              <span v-else class="badge badge-success py-0 px-1" style="font-size: 0.75rem;">已通过</span>
            </div>
            
            <div class="d-flex justify-content-between align-items-center">
              <div style="font-size: 0.8rem; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="mr-2">
                <span class="text-muted mr-1">邀:</span>
                <span class="text-primary font-weight-bold">
                  {{ item.referrer.name }}
                  <span v-if="item.referrer.is_suspicious" class="badge badge-danger py-0 px-1 ml-1" style="font-size: 0.65rem;">嫌</span>
                </span>
                <small class="text-muted">({{ item.referrer.id }})</small>
                <a href="javascript:void(0)" 
                   :class="item.referrer.is_suspicious ? 'text-warning' : 'text-danger'"
                   class="ml-1 text-decoration-none"
                   style="font-size: 0.75rem;"
                   @click.prevent="toggleSuspicious(item.referrer.id, item.referrer.name, !item.referrer.is_suspicious)"
                >
                  [{{ item.referrer.is_suspicious ? '撤嫌' : '嫌疑' }}]
                </a>
                <span class="text-muted mx-1">➔</span>
                <span class="text-success font-weight-bold">{{ item.referee.name }}</span>
                <small class="text-muted">({{ item.referee.id }})</small>
              </div>
              <div class="d-flex align-items-center flex-shrink-0">
                <span class="badge badge-pill badge-warning font-weight-bold py-0 px-1 mr-2" style="font-size: 0.75rem;">+{{ item.points }}</span>
                <template v-if="item.status === 0">
                  <button class="btn btn-sm btn-success py-0 px-2 mr-1" style="font-size: 0.7rem; line-height: 1.5;" @click="audit(item.id, true, item.status)">通过</button>
                  <button class="btn btn-sm btn-danger py-0 px-2" style="font-size: 0.7rem; line-height: 1.5;" @click="audit(item.id, false, item.status)">拒绝</button>
                </template>
                <template v-else-if="item.status === 1">
                  <button class="btn btn-sm btn-outline-danger py-0 px-2" style="font-size: 0.7rem; line-height: 1.5;" @click="audit(item.id, false, item.status)">改未通过</button>
                </template>
              </div>
            </div>
          </div>
          <div v-if="items.length === 0 && !loading" class="text-center py-4 text-muted bg-dark-soft rounded border border-secondary">
            暂无邀请记录
          </div>
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="card-footer bg-transparent border-top border-secondary admin-pagination-row py-3">
        <div class="text-muted small">
          共 {{ total }} 条记录
        </div>
        <div class="pagination-controls d-flex">
          <button 
            class="btn btn-sm btn-outline-secondary mr-2" 
            :disabled="page <= 1"
            @click="changePage(page - 1)"
          >
            上一页
          </button>
          <div class="align-self-center px-2 text-white">第 {{ page }} 页</div>
          <button 
            class="btn btn-sm btn-outline-secondary ml-2" 
            :disabled="page * page_size >= total"
            @click="changePage(page + 1)"
          >
            下一页
          </button>
        </div>
      </div>
    </div>

    <!-- 加载中 -->
    <div v-if="loading" class="loading-overlay d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request'

export default {
  name: 'AdminReferral',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      page_size: 20
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      request_zzquant({
        url: '/v3/user/referral/admin/list',
        params: {
          page: this.page,
          page_size: this.page_size
        }
      }).then(res => {
        if (res.data.code === 20000) {
          this.items = res.data.data.items
          this.total = res.data.data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changePage(p) {
      this.page = p
      this.fetchData()
    },
    audit(record_id, is_pass, currentStatus) {
      let targetAction = '通过'
      if (!is_pass) {
        targetAction = currentStatus === 1 ? '改为未通过并扣回积分' : '拒绝'
      }
      
      this.$bvModal.msgBoxConfirm(`确定要${targetAction}这条记录吗？`, {
        title: '操作确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: is_pass ? 'success' : 'danger',
        okTitle: '确定',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.loading = true;
          request_zzquant({
            url: '/v3/user/referral/admin/audit',
            method: 'POST',
            data: {
              record_id: record_id,
              is_pass: is_pass
            }
          }).then(res => {
            if (res.data.code === 20000) {
              this.$bvToast.toast('审核操作成功', { title: '成功', variant: 'success', solid: true });
              this.fetchData();
            } else {
              this.$bvToast.toast(res.data.msg || '审核失败', { title: '错误', variant: 'danger', solid: true });
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          })
        }
      })
    },
    toggleSuspicious(user_id, user_name, targetStatus) {
      const actionName = targetStatus ? '设为嫌疑人' : '取消嫌疑人状态';
      const promptMsg = targetStatus 
        ? `确定要把用户“${user_name} (ID: ${user_id})”设为嫌疑人吗？设为嫌疑人后，其所有新的邀请都需要人工审核才能得分。`
        : `确定要取消用户“${user_name} (ID: ${user_id})”的嫌疑人状态吗？`;

      this.$bvModal.msgBoxConfirm(promptMsg, {
        title: '操作确认',
        size: 'md',
        buttonSize: 'sm',
        okVariant: targetStatus ? 'danger' : 'success',
        okTitle: '确定',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.loading = true;
          request_zzquant({
            url: '/v3/user/referral/admin/set_suspicious',
            method: 'POST',
            data: {
              user_id: user_id,
              is_suspicious: targetStatus
            }
          }).then(res => {
            if (res.data.code === 20000) {
              this.$bvToast.toast(`成功将用户${actionName}`, { title: '成功', variant: 'success', solid: true });
              this.fetchData();
            } else {
              this.$bvToast.toast(res.data.msg || '操作失败', { title: '错误', variant: 'danger', solid: true });
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.bg-dark-soft {
  background: #1e293b;
}
.loading-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
}
.table th {
  border-top: none;
  background: #0f172a;
  color: #94a3b8;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.table td {
  vertical-align: middle;
  border-top: 1px solid #2d3d51;
}
.badge-warning {
  background-color: #f59e0b;
  color: #000;
}

.admin-pagination-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

/* 手机端及平板适配，对齐 991px 断点 */
@media (max-width: 991px) {
  .admin-pagination-row {
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
}

.referral-mobile-card {
  transition: transform 0.2s, box-shadow 0.2s;
}
.referral-mobile-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4) !important;
}
</style>
